var render = function render(){var _vm=this,_c=_vm._self._c;return _c('image-drag',{ref:"imageListUpload",attrs:{"limit":_vm.limit,"list":_vm.file_list,"multiple":true,"action":_vm.uploadUrl,"on-error":_vm.uploadError,"on-success":_vm.bannerPicSuccess,"before-upload":_vm.beforeAvatarUpload},on:{"update":_vm.updateFile}})
}
var staticRenderFns = []

export { render, staticRenderFns }